import { fetchWrapper, toastWrapper } from '@/_helpers';
import { useState } from 'react';
import { VscLoading } from 'react-icons/vsc';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { css } from 'twin.macro';

const BuildNewForm = ({ teamId, channelId, adminPanel, currUser, linkTo }) => {
    const history = useHistory();
    const [isBusy, setIsBusy] = useState(false);

    const createNewForm = async () => {
        try {
            console.log({ currUser });
            if (isBusy) return;
            setIsBusy(true);
            const formData = {
                name: `New Form: ${currUser?.name || ''} [draft-${Date.now()}]`,
                team: teamId ? [teamId] : [],
                data: [],
                chatroom: channelId ? [channelId] : [],
                draft: true,
            };
            const response = await fetchWrapper.post('forms', formData);
            if (response && response._id) {
                let targetUrl = '';
                if (linkTo) {
                    targetUrl = `${linkTo}/${response._id}`;
                } else {
                    targetUrl = adminPanel
                        ? `/master-form-library/edit/${response._id}`
                        : `/form-library/edit/${response._id}`;
                }
                history.push(targetUrl);
            }
        } catch (err) {
            console.error('Error creating form:', err);
            toastWrapper.error(err?.message || 'Something went wrong while creating form');
        } finally {
            setIsBusy(false);
        }
    };

    return (
        <button className="btn button-green" onClick={createNewForm} disabled={isBusy}>
            <h4
                css={css`
                    width: 12rem;
                `}
            >
                {isBusy ? (
                    <span>
                        <VscLoading className="spin mr-2" /> Please wait
                    </span>
                ) : (
                    'Build a New Form'
                )}
            </h4>
        </button>
    );
};

const mapStateToProps = (state) => ({
    currUser: state.user.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BuildNewForm);
